import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import Button from 'js/components/common/Button';

import Container from './Container';
import Title from './Title';
import SubTitle from './SubTitle';

@inject('page')
@observer
export default class IPAddressesMatchNotification extends Component {
  onSubmit = (event, formValues) => this.props.onSubmit(formValues);
  onCancel = (event) => this.props.onCancel();

  render() {
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>

          <Title>Transaction Alert</Title>

          <SubTitle>
            <br/>It seems the buyer and seller are in the same location. You will not be able to proceed with this transaction.<br/><br/>
            If you would like to know how PayOnDelivery works <a href="https://vimeo.com/355366890" target="_blank">click here</a>.<br/><br/>
            If you’re receiving this message in error please contact <a href="mailto:help@payondelivery.com">help@payondelivery.com</a>.
          </SubTitle>

          <Button type="submit">
            OK
          </Button>

        </AvForm>
      </Container>
    );
  }
}
